export default __webpack_public_path__ + "static/media/flag-guadeloupe.6e9161bd.svg";